// 会社ロゴの無限スクロール機能

const initCompanyInfiniteScroll = () => {
  if (isInitialized() === true) return;
  duplicateListElements();
  animateScroll();
};

const isInitialized = () => {
  const scrollContainer = document.querySelector(
    ".home-companies__scroll-container",
  ) as HTMLElement;
  if (scrollContainer.querySelectorAll(".home-companies__scroll-content").length > 1) {
    return true;
  }
  return false;
};

const duplicateListElements = () => {
  const scrollContainer = document.querySelector(
    ".home-companies__scroll-container",
  ) as HTMLElement;
  const scrollContent = scrollContainer?.querySelector(
    ".home-companies__scroll-content",
  ) as HTMLElement;

  if (!scrollContainer || !scrollContent) return;

  // すでに複製されている場合は何もしない
  if (scrollContainer.querySelectorAll(".home-companies__scroll-content").length > 1) {
    return;
  }

  // ul.home-companies__scroll-contentを直後に複製。3つ。
  for (let i = 0; i < 2; i++) {
    const clonedContent = scrollContent.cloneNode(true) as HTMLElement;
    clonedContent.classList.remove("style-repeat-1");
    clonedContent.classList.add(`style-repeat-${i + 2}`);
    scrollContainer.appendChild(clonedContent);
  }
};

const animateScroll = async () => {
  const scrollContainer = document.querySelector(
    ".home-companies__scroll-container",
  ) as HTMLElement;
  const firstScrollContent = scrollContainer?.querySelector(
    ".home-companies__scroll-content.style-repeat-1",
  ) as HTMLElement;

  if (!scrollContainer || !firstScrollContent) return;

  // style-repeat-1の幅を取得
  let contentWidth = firstScrollContent.offsetWidth;
  if (contentWidth < 1000) {
    // 待機
    await new Promise((resolve) => setTimeout(resolve, 300));
    contentWidth = firstScrollContent.offsetWidth;
  }

  let currentTranslateX = 0;

  const scroll = () => {
    // 1フレームあたりの移動距離（調整可能）
    const scrollSpeed = 1;
    currentTranslateX -= scrollSpeed;

    // 1個分のコンテンツ幅だけスクロールしたら初期状態にリセット
    if (Math.abs(currentTranslateX) >= contentWidth) {
      currentTranslateX = 0;
    }

    // transformを適用してスクロール
    scrollContainer.style.transform = `translateX(${currentTranslateX}px)`;

    // 次のフレームで再実行
    requestAnimationFrame(scroll);
  };

  // アニメーション開始
  requestAnimationFrame(scroll);
};

// DOMContentLoadedイベントで初期化
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    initCompanyInfiniteScroll();
  }, 10);
});

// ページ遷移時にも対応（SPA的な動作がある場合）
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCompanyInfiniteScroll);
} else {
  initCompanyInfiniteScroll();
}
